import * as z from "zod";

export const MAX_SHIPPING_METHOD_IDENTITIES = 25;
export const MAX_SHIPPING_METHOD_IDENTITY_BYTES = 128;

export const shippingMethodIdentitySchema = z.object({
  field: z.literal("TITLE"),
  operator: z.literal("IS"),
  value: z.string().min(1).max(MAX_SHIPPING_METHOD_IDENTITY_BYTES),
});

export const shippingMethodFamilySchema = z
  .array(shippingMethodIdentitySchema)
  .min(1)
  .max(MAX_SHIPPING_METHOD_IDENTITIES);
